import { render, staticRenderFns } from "./CapitalStep.vue?vue&type=template&id=5f89c7e4&"
import script from "./CapitalStep.vue?vue&type=script&lang=js&"
export * from "./CapitalStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports